'use client';
import {useEffect, useState} from 'react';
import main from "@/libs/main";
import CommonDataContextProvider from '@/providers/CommonDataContext';
import CartContextProvider from '@/providers/CartContext';
import WishlistContextProvider from '@/providers/WshlistContext';
import ProductContextProvider from '@/providers/ProductContext';
// import Preloader from '@/components/shared/others/Preloader';
import UserContextProvider from '@/providers/UserContext';

export default function ClientProviders({children, commonData, userData}) {
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    main();
    setLoading(false);
  }, []);
  
  return (
      <>
        {/*<Preloader loading={loading}/>*/}
        <UserContextProvider user={userData}>
          <CommonDataContextProvider value={commonData}>
            <CartContextProvider>
              <WishlistContextProvider>
                <ProductContextProvider>
                  {children}
                </ProductContextProvider>
              </WishlistContextProvider>
            </CartContextProvider>
          </CommonDataContextProvider>
        </UserContextProvider>
        {
          !!commonData?.contact?.telNumber || !!commonData?.contact?.whatsapp || !!commonData?.contact?.telegram
              ? (
                  <div className="contact-wrapper">
                    {
                      !!commonData?.contact?.telNumber
                          ? (
                              <div
                                  className="contact-icon i-phone"
                                  onClick={() => window.open(`tel:${commonData.contact.parsedTelNumber}`)}
                              >
                                <i className="fa-solid fa-phone"></i>
                              </div>
                          ) : ''
                    }
                    {
                      !!commonData?.contact?.whatsapp
                          ? (
                              <div
                                  className="contact-icon i-whatsapp"
                                  onClick={() => window.open(commonData.contact.whatsapp)}
                              >
                                <i className="fa-brands fa-whatsapp"></i>
                              </div>
                          ) : ''
                    }
                    {
                      !!commonData?.contact?.telegram
                          ? (
                              <div
                                  className="contact-icon i-telegram"
                                  onClick={() => window.open(commonData.contact.telegram)}
                              >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 448 512"
                                >
                                  <path
                                      d="M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"/>
                                </svg>
                              </div>
                          ) : ''
                    }
                  </div>
              ) : ''
        }
      </>
  );
};
